export default "__VITE_ASSET__DzAuHVXz__"